import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
})
export class AlertComponent {
  message: '';
  confirmButtonText = 'Yes';
  cancelButtonText = 'No';
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AlertComponent>,
    private translate: TranslateService
  ) {
    this.message =
      this.translate.instant(data?.message, { value: data?.value }) || this.data?.message;
    this.confirmButtonText = this.translate.instant('global.yes') || this.confirmButtonText;
    this.cancelButtonText = this.translate.instant('global.no') || this.cancelButtonText;
  }

  onConfirmClick(): void {
    this.dialogRef.close('true');
  }
}
